module.exports = __webpack_public_path__ + "static/img/home-customer.7fd50605.png";